export default "__VITE_ASSET__DOOW23Ot__"